import React, { useState } from 'react'
import Points from '@/_components/Points'
import DetailButton from '@/_components/DetailButton'
import Home2Icon from '@/_assets/icon-components/Home2'
import { useTranslations } from 'next-intl'

export default function PointAction() {
  const [isAddress, setIsAddress] = useState(false)
  const t = useTranslations()

  return (
    <div>
      <DetailButton
        label={t('my_address')}
        leftIcon={<Home2Icon />}
        onClick={() => setIsAddress(true)}
      />
      <Points isOpen={isAddress} onClose={() => setIsAddress(false)} />
    </div>
  )
}
